<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import Identity from 'svelte-key'
  import { fetchData, generateID, getLinkedRows, getLocalServer } from '../shared/utils/Data.svelte';
  import { sortByName, ignoreCaseSort, sortByLabel } from '../shared/utils/Sort.svelte';
  import Node from '../shared/sidebar/Node.svelte';
  import { collect } from '../shared/grid/data-grid';
  import { person, logOut, addCircleOutline, cube, map, headset, videocam, document, link, bookmark, refresh, image, today, arrowRoundBack, create, eye, list, download, informationCircleOutline } from 'ionicons/icons/index.mjs';

  export let session;
  export let content;
  export let settings;
  export let tables;
  let selected = [];
  let links = [];
  let media = {};
  let keys = {
			links: "1"
		}
  let linkFeatures = {};

  const dispatch = createEventDispatcher();

  onMount(async () => {
    if (content.feature && content.feature.properties && content.table.id_field) {
      var path = "/v1/media/layer/" + content.table.media_id + "/" + content.feature.properties[content.table.id_field];
      let [res, err]  = await fetchData(path, {
          headers: {
              'Authorization': 'Bearer ' + session.token
          }
      });
      if (err) {
          console.log(err);
          return;
      }
      media = res.data.media;
    }
    
    if (content.table.links) {
      content.table.links.split(",").map(async function (link) {
        var table = tables.find(x => x.id === link);
        var ids = table.source.split("_");
        if (table.dynamic) {
          let [res, err]  = await fetchData("/v1/tables/" + ids[1] + "_" + ids[2] + "/" + content.feature.properties[content.table.id_field], {
              method: "POST",
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + session.token
              },
            body: JSON.stringify({
              link_field: table.link_field
            })
          });
          if (!err) {
            buildLinkTable(table, res.features);
          } 
        }
        else {
          if (ids[0] == "source") {
            getLinkedRows("source_" + ids[1], content.feature.properties[content.table.id_field], table.link_field, function (rows) {
              buildLinkTable(table, rows);
            });
          }
          else if (ids[0] == "layer") {
            getLinkedRows(table.source, content.feature.properties[content.table.id_field], table.link_field, function (rows) {
              buildLinkTable(table, rows);
            });
          }
        }
      })
    }
        /*if (source) {
            columns = [];
            rows = [];
            title = "";
            if (content.table.name)
                title = content.table.name;
            var columnNames = {};
						if (content.table.fields) {
							content.table.fields.split(",").map(function (field) {
								columnNames[field] = {
										label: field,
										field: field,
										numeric: false,
										html: true
								}
							})
							source.features.map(function (feature) {
									rows.push(feature.properties);
							})
						}
						else {
							source.features.map(function (feature) {
									Object.keys(feature.properties).map(function (k) {
											columnNames[k] = {
													label: k,
													field: k,
													numeric: typeof feature.properties[k] === "number" ? true : false,
													html: true
											}
									});
									rows.push(feature.properties);
							})
						}
            columns = Object.values(columnNames).sort(sortByLabel);
            setPerPageOptions();		
        }	*/
	});
  function buildLinkTable(table, features) {
    var columns = [];
    var rows = [];
    var title = "";
    if (table.name) {
      title = table.name;
    }
    var columnNames = {};
    linkFeatures[table.id] = features;
    if (table.fields) {
      table.fields.split(",").map(function (field) {
        columnNames[field] = {
            label: field,
            field: field,
            numeric: false,
            html: true
        }
      })
      features.map(function (feature, i) {
          feature.properties["__index"] = i;
          rows.push(feature.properties);
      })
    }
    else {
      features.map(function (feature, i) {
          Object.keys(feature.properties).map(function (k) {
              columnNames[k] = {
                  label: k,
                  field: k,
                  numeric: typeof feature.properties[k] === "number" ? true : false,
                  html: true
              }
          });
          feature.properties["__index"] = i;
          rows.push(feature.properties);
      })
    }
    columns = Object.values(columnNames).sort(sortByLabel);
    links.push({
      rows: rows,
      columns: columns,
      title: title,
      table: table,
      selected: -1
    });
    keys.links = generateID();
  }
  function sendMessage(message) {
		dispatch('message', message);
  }
</script>

<div id="stage" class="container panel" in:fade>
  <div class="panel-header">
    <div class="tile tile-centered">
      <div class="tile-content">
        {#if content.feature}
        <div class="h5 tile-title" style="padding-left:1.5rem;">{content.feature.properties[content.table.label_field]}</div>
        {/if}
      </div>
      <div class="tile-action">
        <div class="actions">
          {#if content.table.form}
            <button
              class="btn btn-link tooltip tooltip-left" data-tooltip="New Report"
              on:click="{(e) => {
                e.currentTarget.blur();
                sendMessage({
                  type: "report",
                  data: {
                    form: content.table.form
                  }
                })
              }}">
              <i class="svg">{@html today.md}</i>
            </button>
            <button
              class="btn btn-link tooltip tooltip-left" data-tooltip="Edit Feature"
              on:click="{(e) => {
                e.currentTarget.blur();
                sendMessage({
                  type: "edit",
                  data: {
                    form: content.table.form,
                    feature: content.feature
                  }
                })
              }}">
              <i class="svg">{@html create.md}</i>
            </button>
          {/if}
          {#if content.table.summaries}
            <button
              class="btn btn-link tooltip tooltip-left" data-tooltip="Summary"
              on:click="{(e) => {
                e.currentTarget.blur();
                let images = {};
                selected.map(function (uri, i) {
                  images["media" + i] = uri;
                })
                console.log(content.table);
                sendMessage({
                  type: "modal",
                  data: {
                    view: "summaries",
                    type: "item",
                    feature: {
                      ...content.feature,
                      ...images
                    },
                    layer: content.table.media_id,
                    feature_id: content.feature.properties[content.table.id_field]
                  }
                })
              }}">
              <i class="svg">{@html list.ios}</i>
            </button>
          {/if}
          <button
            class="btn btn-link tooltip tooltip-left" data-tooltip="Back"
            on:click="{(e) => {
              e.currentTarget.blur();
              window.history.back();
            }}">
            <i class="svg">{@html arrowRoundBack.md}</i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="columns">
      <div class="column col-sm-12 col-6">
        <table class="table table-striped"> 
          <tbody>
            {#if content.feature}
            {#each Object.keys(content.feature.properties) as prop, i}
              {#if prop != "__index"}
                <tr><td>{prop}</td><td>{content.feature.properties[prop]}</td></tr>
              {/if}
            {/each}
            {/if}
          </tbody>
        </table>
      </div>
      <div class="column col-sm-12 col-6">
        <div class="tile tile-centered pl-2">
          <div class="tile-content">
              <div class="divider" data-content="MEDIA"></div>
          </div>
						<div class="tile-action">
							{#if content.table.role > 1}
								<button class="btn btn-link tooltip tooltip-left" data-tooltip="Add Media" on:click={(e) => {
									e.currentTarget.blur();
										sendMessage({
											type: "modal",
											data: {
												view: "mediaUpload",
												id: content.table.id,
												role: content.table.role,
                        layer: content.table.media_id,
                        feature: content.feature.properties[content.table.id_field]
											}
										})
									}}>
									<i class="svg">{@html addCircleOutline.md}</i>
								</button>
							{/if}
						</div>
          </div>
					{#if Object.keys(media).length > 0}
						{#each Object.keys(media).sort(ignoreCaseSort) as section}
							<div class="accordion" in:fade>
								<input type="checkbox" id={"table-" + section} name="accordion-checkbox" hidden>
								<label class="accordion-header" for={"table-" + section}>
									<div class="tile tile-centered">
										<div class="tile-icon">
											<div class="example-tile-icon">
											<i class="icon icon-arrow-right centered"></i>
											</div>
										</div>
										<div class="tile-content">
											<div class="tile-title">{section}</div>
										</div>
									</div>    
								</label>
								<div class="accordion-body">
									<ul class="menu menu-nav">
										{#if Object.values(media[section]).length > 0}
											{#each Object.values(media[section]).sort(sortByName) as item}
												<div class="tile tile-centered">
                          <div class="tile-icon" style="width:20px;">
                              <div class="type-icon">
                                  {#if item.type == "link"}
                                      <i class="svg">{@html link.md}</i>
                                  {:else if item.type == "download"}
                                      <i class="svg">{@html download.md}</i>
                                  {:else if item.type == "pdf" || item.type == "document"}
                                      <i class="svg">{@html bookmark.md}</i>
                                  {:else if item.type == "image"}
                                      <i class="svg">{@html image.md}</i>
                                  {:else if item.type == "360"}
                                      <i class="svg">{@html refresh.md}</i>
                                  {:else if item.type == "audio"}
                                      <i class="svg">{@html headset.md}</i>
                                  {:else if item.type == "video"}
                                      <i class="svg">{@html videocam.md}</i>
                                  {:else}
                                      <i class="svg">{@html document.md}</i>
                                  {/if}
                              </div>
                          </div>
													<div class="tile-content">
														<li class="menu-item">
                              {#if item.type == "image"}
                                <input type="checkbox" value={item.uri} bind:group={selected} />
                              {/if}
															{#if settings.newTab && (item.type == "link" || item.type == "pdf")}
																<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                              {:else if item.type == "download"}
												      	{#if window.platform == "Windows"}
																	<button class="btn btn-link" on:click|stopPropagation={async (e) => {
																		e.currentTarget.blur();
																		let [res, err]  = await fetchData(getLocalServer() + "/core", {
																			method: "POST",
																			headers: {
																					'Accept': 'application/json',
																					'Content-Type': 'application/json'
																			},
																			body: JSON.stringify({
																				url: item.uri
																			})
																		});
																		if (err || !res.found) {
																				window.open(item.uri, "_blank");
																		}
																	}}>
																	{item.name}
																	</button>
																{:else}
																	<a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
																{/if}
															{:else}
																<button class="btn btn-link"
																on:click|stopPropagation={(e) => {
																	e.currentTarget.blur();
																	sendMessage({
																		type: "modal",
																		data: {
																			view: "mediaView",
																			media: item,
																		}
																	})
																}}>{item.name}</button>
															{/if}
														</li>
													</div>
													<div class="tile-action">
                            <button class="btn btn-link tooltip tooltip-left" data-tooltip="Details" on:click|stopPropagation={(e) => {
                                  e.currentTarget.blur();
                                  sendMessage({
                                    type: "modal",
                                    data: {
                                      view: "mediaUpload",
                                      id: content.table.id,
                                      group: section,
                                      media: item,
                                      role: content.table.role,
                                      layer: content.table.media_id,
                                      feature: content.feature.properties[content.table.id_field]
                                    }
                                  })
                                }}>
                              <i class="svg">{@html informationCircleOutline.md}</i>
                            </button>
													</div>
												</div>
											{/each}
										{/if}
									</ul>
								</div>
							</div>
						{/each}
					{/if}
        <Identity key={keys.links}>
        {#each links as link}
          <div class="tile tile-centered pl-2">
            <div class="tile-content">
                <div class="divider" data-content="{link.title}"></div>
            </div>
            <div class="tile-action">
              {#if link.table.role >= 2 && link.table.form}
              <button class="btn btn-link tooltip tooltip-left" data-tooltip="New Report" on:click={(e) => {
                  e.currentTarget.blur();
                  sendMessage({
                    type: "edit",
                    data: {
                      form: link.table.form,
                      feature: content.feature
                    }
                  })
                }}>
                <i class="svg">{@html today.md}</i>
              </button>
              <button class="btn btn-link tooltip tooltip-left" data-tooltip="Edit Feature" on:click={(e) => {
                  e.currentTarget.blur();
                  sendMessage({
                    type: "edit",
                    data: {
                      form: link.table.form,
                      feature: linkFeatures[link.table.id][link.selected]
                    }
                  })
                }}>
                <i class="svg">{@html create.md}</i>
              </button>
              {/if}
              <button class="btn btn-link tooltip tooltip-left" data-tooltip="View" on:click={(e) => {
                  e.currentTarget.blur();
                  history.replaceState(content, "", window.location);
                  if (link.selected != -1) {
                    var data = {
                        view: "item",
                        table: link.table,
                        feature: linkFeatures[link.table.id][link.selected]
                      }
                    sendMessage({
                      type: "content",
                      data: data
                    })
                    var url = window.location.origin + "/tables/" + data.table.id + "?f=" + data.feature.properties[data.table.id_field];
						        history.pushState(data, "", url);
                  }
                }}>
                <i class="svg">{@html eye.md}</i>
              </button>
						</div>
          </div>
          <table
            class="table table-striped table-hover table-scroll">
              <thead>
                  <tr>
                      {#each link.columns as column, x}
                      <th
                          style="width: { column.width ? column.width : 'auto' }">
                          {column.label}
                      </th>
                      {/each}
                  </tr>
              </thead>
              <tbody>
                {#each link.rows as row, y}
                  <tr class="clickable { link.selected == y ? 'active' : '' }" on:click={(e) => {
								  	e.currentTarget.blur();
                    link.selected = y;
                    keys.links = generateID();
									}}>
                      {#each link.columns as column}
                          <td>
                              {#if column.html}
                                  {@html collect(row, column.field)}
                              {:else}
                                  { collect(row, column.field) }   
                              {/if}     
                          </td>    
                      {/each}
                  </tr>
                {/each}
              </tbody>
          </table>
        {/each}
        </Identity>
                </div>
      </div>
    </div>
</div>

<style>
	#stage {
		width: 100vw;
		height: 100vh;
	}
	.panel .panel-header, .panel .panel-body {
		padding: 0;
    overflow-x: hidden;
	}
  .panel .panel-header {
		border-bottom: 1px solid #00ab5f;
	}
  table {
		table-layout: fixed;
    width: 100%;
	}
	table tr td {
		padding: 0 0 0 56px;
		height: 48px;
		font-size: 13px;
		color: rgba(0, 0, 0, 0.87);
		border-bottom: solid 1px #DDDDDD;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	table td, table th {
    	border-radius: 0;
	}
	table tr {
		font-size: 12px;
	}
	table th {
		font-size: 12px;
		font-weight: 500;
		color: #757575;
		white-space: nowrap;
		padding: 0;
		height: 2rem;
		padding-left: 56px;
		vertical-align: middle;
		outline: none !important;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	table tbody tr:hover {
		background-color: #EEE;
	}
	
	table th:last-child,
	table td:last-child {
		padding-right: 14px;
	}
	table th:first-child, table td:first-child {
		padding-left: 24px;
	}
	.table tbody tr.active, .table.table-striped tbody tr.active {
		background-color: #a9d9bb;
	}
</style>